import { getAllEmissionYears, getAllSubmissionYears } from '~/api/dimensions';

export interface TimeDimension {
  name: string;
  id: number;
}

class DimensionsServiceClass {
  private submissionYears: Promise<TimeDimension[]> | undefined;
  private emissionYears: Promise<TimeDimension[]> | undefined;

  /**
   * The API might return "NO_YEAR", which needs to be filtered away
   * @param dimensions the dimensions to filter
   */
  private filterYears(dimensions: TimeDimension[]): TimeDimension[] {
    return dimensions.filter((x) => Number.parseInt(x.name));
  }

  private sortNewFirst(dimensions: TimeDimension[]): TimeDimension[] {
    const sorter = (leftHand: TimeDimension, rightHand: TimeDimension): number =>
      Number.parseInt(rightHand.name) - Number.parseInt(leftHand.name);

    return dimensions.sort(sorter);
  }

  private sortOldFirst(dimensions: TimeDimension[]): TimeDimension[] {
    const sorter = (leftHand: TimeDimension, rightHand: TimeDimension): number =>
      Number.parseInt(leftHand.name) - Number.parseInt(rightHand.name);

    return dimensions.sort(sorter);
  }

  public getSubmissionYears(): Promise<TimeDimension[]> {
    if (this.submissionYears) {
      return this.submissionYears;
    }

    return (this.submissionYears = getAllSubmissionYears().then(this.filterYears).then(this.sortNewFirst));
  }

  public getEmissionYears(): Promise<TimeDimension[]> {
    if (this.emissionYears) {
      return this.emissionYears;
    }

    return (this.emissionYears = getAllEmissionYears().then(this.filterYears).then(this.sortOldFirst));
  }
}
export const DimensionsService = new DimensionsServiceClass();
